import { SVGProps } from "react";

export default function CalendarRightDotsIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.3359 1.6665V4.1665"
        stroke="#545454"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66406 1.6665V4.1665"
        stroke="#545454"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0859 7.5752L2.91927 7.5752"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 7.08317L2.5 14.1665C2.5 16.6665 3.75 18.3332 6.66667 18.3332H13.3333C16.25 18.3332 17.5 16.6665 17.5 14.1665V7.08317C17.5 4.58317 16.25 2.9165 13.3333 2.9165L6.66667 2.9165C3.75 2.9165 2.5 4.58317 2.5 7.08317Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.002 11.4167H9.99449"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0879 11.4167H13.0804"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0879 13.9167H13.0804"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
